"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[311],{

/***/ 40311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_WhyCarPlannerContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/icons/green_car.tsx
var green_car = __webpack_require__(22339);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/green_click.tsx



const GreenClickIcon = () => /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      id: "j7cczu7vbb",
      d: "M0 0.22L11.433 0.22 11.433 4.167 0 4.167z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      id: "xzcebcwtwd",
      d: "M0.517 0.463L31.653 0.463 31.653 31.579 0.517 31.579z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      id: "vgq0d26i8f",
      d: "M0.589 0.35L4.536 0.35 4.536 11.782 0.589 11.782z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("filter", {
      id: "ppl26g0uja",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
        in: "SourceGraphic",
        values: "0 0 0 0 0.254902 0 0 0 0 0.643137 0 0 0 0 0.462745 0 0 0 1.000000 0"
      })
    })]
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-680 -2666) translate(160 2566) translate(0 100) translate(403) translate(117)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "40",
        cy: "40",
        r: "40",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        filter: "url(#ppl26g0uja)",
        transform: "translate(10 10)",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            transform: "translate(5 5) translate(0 16.876)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
              id: "xiab0x1u1c",
              fill: "#fff",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                xlinkHref: "#j7cczu7vbb"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              fill: "#1D1D1B",
              d: "M9.46.22H1.972C.885.22 0 1.106 0 2.194s.885 1.973 1.973 1.973H9.46c1.088 0 1.974-.885 1.974-1.973S10.547.22 9.459.22",
              mask: "url(#xiab0x1u1c)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            transform: "translate(5 5) translate(15.072 16.158)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
              id: "17b24do8we",
              fill: "#fff",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                xlinkHref: "#xzcebcwtwd"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              fill: "#1D1D1B",
              d: "M24.8 12.702l-11.483 11.49L5.965 5.81 24.8 12.702zm6.273 15.503l-8.13-8.11 6.838-6.792c.48-.478.68-1.159.531-1.823-.15-.656-.614-1.189-1.25-1.427L3.162.577c-.73-.26-1.548-.069-2.088.487-.538.556-.704 1.38-.42 2.107l10.105 25.262c.247.623.79 1.072 1.49 1.207.13.017.263.02.394.005.507-.012.984-.214 1.35-.575l6.182-6.175 8.104 8.104c.374.376.882.58 1.4.58.17 0 .34-.022.51-.067.68-.183 1.215-.718 1.397-1.398.182-.68-.014-1.411-.513-1.909z",
              mask: "url(#17b24do8we)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            transform: "translate(5 5) translate(15.79 .368)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
              id: "mtbvni13hg",
              fill: "#fff",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                xlinkHref: "#vgq0d26i8f"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              fill: "#1D1D1B",
              d: "M2.566 11.782c1.08-.006 1.964-.89 1.97-1.974V2.323c0-1.088-.886-1.974-1.974-1.974S.59 1.235.59 2.323v7.485c0 1.089.885 1.974 1.977 1.974",
              mask: "url(#mtbvni13hg)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: "#1D1D1B",
            d: "M7.582 5.233l-.076-.067c-.785-.584-1.862-.513-2.561.172-.7.686-.794 1.76-.225 2.557l6.703 6.717c.365.374.875.588 1.399.588.522 0 1.032-.214 1.388-.578.374-.366.588-.876.588-1.398 0-.524-.214-1.033-.584-1.396L7.582 5.233z",
            transform: "translate(5 5)"
          })]
        })
      })]
    })
  })]
});

/* harmony default export */ var green_click = (GreenClickIcon);
;// CONCATENATED MODULE: ./src/icons/green_support.tsx



const GreenSupportIcon = () => /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      id: "ha99th8kfb",
      d: "M0 0.425L45 0.425 45 50.727 0 50.727z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      id: "w65j6s05nd",
      d: "M0 51.12L45 51.12 45 0.819 0 0.819z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("filter", {
      id: "vadlqil5za",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
        in: "SourceGraphic",
        values: "0 0 0 0 0.254902 0 0 0 0 0.643137 0 0 0 0 0.462745 0 0 0 1.000000 0"
      })
    })]
  }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-1083 -2666) translate(160 2566) translate(0 100) translate(806) translate(117)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "40",
        cy: "40",
        r: "40",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        filter: "url(#vadlqil5za)",
        transform: "translate(10 10)",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          transform: "translate(7.5 2.5)",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            transform: "translate(0 .393)",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
              id: "34k0nzljnc",
              fill: "#fff",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
                xlinkHref: "#ha99th8kfb"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              fill: "#1D1D1B",
              d: "M19.964 34.507c1.298.398 2.644.603 4.008.61.355 0 .711-.016 1.064-.046v1.109c0 1.398-1.137 2.536-2.536 2.536-1.398 0-2.536-1.138-2.536-2.536v-1.673zm13.91-26.338c-.892.172-1.582.342-2.104.475-1.578.446-3.214.651-4.862.618-1.607.043-3.175-.21-4.68-.742-1.328-.485-2.721-.731-4.14-.731h-.007c-1.037 0-1.881.843-1.881 1.882v2.536h-2.127V8.198c.007-2.204 1.806-4.003 4.008-4.01h15.792v3.98zM14.526 24.33c.194-.076.384-.165.57-.263l3.128 3.142c.357.346.828.538 1.33.543h4.826v-3.764h-4.054l-2.575-2.577c.476-.892.73-1.888.738-2.907-.003-.877-.193-1.742-.555-2.534h.146c1.039 0 1.883-.845 1.883-1.882V11.77c.367.091.733.202 1.093.334 1.894.649 3.867.947 5.854.921 1.957.037 3.913-.212 5.793-.734.369-.095.753-.19 1.17-.279v9.444c.034 4.983-3.666 9.224-8.609 9.863-4.824.623-9.37-2.363-10.738-6.988zm.2-5.824c0 1.398-1.137 2.536-2.534 2.536-1.396-.004-2.535-1.143-2.539-2.537 0-1.398 1.139-2.535 2.537-2.535 1.399 0 2.537 1.137 2.537 2.536zM36 37.49L28.8 34.863v-.65c5.292-1.995 8.831-7.086 8.837-12.76V2.307c0-1.038-.845-1.882-1.882-1.882H18.08c-4.285 0-7.772 3.487-7.772 7.773v4.315c-2.692.834-4.493 3.328-4.416 6.172.077 2.863 2.035 5.27 4.794 5.939.596 2.453 1.841 4.695 3.62 6.503.588.57 1.223 1.099 1.893 1.57v2.166L9.004 37.49C3.618 39.436 0 44.592 0 50.318v.41h3.763v-.41c.001-4.147 2.62-7.88 6.521-9.291l6.457-2.352c.977 2.292 3.241 3.806 5.76 3.806 2.517 0 4.78-1.514 5.759-3.806l6.457 2.352c3.9 1.41 6.519 5.144 6.52 9.291v.41H45v-.41C45 44.592 41.383 39.437 36 37.49z",
              mask: "url(#34k0nzljnc)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
            id: "rcpjm64ane",
            fill: "#fff",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("use", {
              xlinkHref: "#w65j6s05nd"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: "#1D1D1B",
            d: "M20.618 19.309L24.382 19.309 24.382 15.545 20.618 15.545zM27.982 19.31L31.745 19.31 31.745 15.546 27.982 15.546z",
            mask: "url(#rcpjm64ane)"
          })]
        })
      })]
    })
  })]
});

/* harmony default export */ var green_support = (GreenSupportIcon);
;// CONCATENATED MODULE: ./src/containers/data/WhyCarplannerData.tsx


const WhyCarPlannerData = [{
  title: 'Cerca l’auto perfetta\nper le tue esigenze!',
  description: 'Selezioniamo per te le migliori offerte sul mercato per il Noleggio a Lungo Termine e l’Acquisto!',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_car/* default */.Z, {})
}, {
  title: 'Acquista o Noleggia\n online in pochi passi',
  description: 'Ti guidiamo nella scelta della tua nuova auto con un servizio semplice, veloce e trasparente, ottimizzando i tempi!',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_click, {})
}, {
  title: 'Consulenti esperti sempre\n a tua disposizione',
  description: 'Il cliente sempre al centro: puoi contare sulla nostra esperienza per rispondere a tutte le tue domande e consigliarti al meglio! ',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_support, {})
}];
/* harmony default export */ var WhyCarplannerData = (WhyCarPlannerData);
;// CONCATENATED MODULE: ./src/containers/WhyCarPlannerContainer.tsx





const WhyCarPlannerList = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(7620), __webpack_require__.e(570)]).then(__webpack_require__.bind(__webpack_require__, 15562)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(15562)]
  }
});

const WhyCarPlannerContainer = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhyCarPlannerList, {
      title: title,
      items: WhyCarplannerData
    })
  });
};

/* harmony default export */ var containers_WhyCarPlannerContainer = (WhyCarPlannerContainer);

/***/ }),

/***/ 22339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



const GreenCarIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
      transform: "translate(-277 -2666) translate(160 2566) translate(0 100) translate(117)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
        cx: "40",
        cy: "40",
        r: "40",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M10.468 47.5c1.294 0 2.344-1.05 2.344-2.344v-2.343h34.375v2.343c0 1.294 1.05 2.344 2.344 2.344h1.562c1.294 0 2.344-1.05 2.344-2.344V31.875c0-1.718-.492-3.305-1.3-4.687h1.105c.538 0 1.007-.366 1.137-.887l.586-2.344c.184-.74-.375-1.456-1.138-1.456h-5.099l-3.062-7.605C44.476 11.937 41.607 10 38.42 10H21.58c-3.188 0-6.057 1.937-7.247 4.895L11.27 22.5H6.172c-.762 0-1.322.717-1.136 1.456l.586 2.344c.122.49.632.887 1.136.888h1.105c-.809 1.382-1.3 2.97-1.3 4.686v13.282c0 1.294 1.049 2.344 2.343 2.344h1.562zm33.207-25h-27.35l2.356-5.855c.479-1.189 1.617-1.957 2.899-1.957h16.84c1.282 0 2.42.768 2.898 1.957l2.357 5.854zm3.512 15.625H12.812c-.861 0-1.562-.701-1.562-1.562v-4.688c0-2.585 2.102-4.687 4.687-4.687h28.125c2.585 0 4.688 2.102 4.688 4.687v4.688c0 .86-.701 1.562-1.563 1.562zm-25-3.92c0-1.87-2.812-4.675-4.687-4.675-1.875 0-3.125 1.246-3.125 3.117 0 1.87 1.25 3.116 3.125 3.116s4.687.311 4.687-1.559zM42.5 35.762c1.875 0 3.125-1.246 3.125-3.116s-1.25-3.117-3.125-3.117-4.688 2.805-4.688 4.674c0 1.87 2.813 1.559 4.688 1.559z",
          transform: "translate(10 10)"
        })
      })]
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (GreenCarIcon);

/***/ })

}]);